<template>
  <div id="login">
    <div class="left-column"></div>
    <div class="right-column">
      <div class="column-content">
        <div class="title">
          <h1>{{$t('register.title')}}<br><span>{{$t('login.byMobivia')}}</span></h1>
        </div>
        <div>
          <form>
            <div class="content">
              <div class="title" v-text="email"></div>
              <div class="wrongAuthentification"><pre>{{wrongAuthentificationMessage}}</pre>
              </div>
              <div class="success">{{successMessage}}</div>
              <input type="password" name="password" v-bind:placeholder="$t('register.password')" v-model="password" v-on:keyup.enter="onSubmit">
              <input type="password" name="password" v-bind:placeholder="$t('register.confPassword')" v-model="confPassword" v-on:keyup.enter="onSubmit">
            </div>
            <footer>
              <div class="btn submit" @click="onSubmit">{{$t('register.confirmer')}}</div>
            </footer>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  directives: {
  },
  components: {
  },
  data() {
    return {
      email: this.$route.query.email,
      token: this.$route.query.token,
      password: '',
      confPassword: '',
      wrongAuthentificationMessage: '',
      successMessage: ''
    }
  },
  computed: {
  },
  methods: {
    onSubmit () {
      let password = this.password,
      confPassword = this.confPassword,
      brText = '\n',
      baseErrorMessage = this.$t('register.invalidPassword') + brText,
      errorMessage = baseErrorMessage

      if(password.length < 8) {
        errorMessage += this.$t('register.minLength') + brText
      }
      if(!new RegExp(/\d/).test(password)) { // Check there is at least one number in the password
        errorMessage += this.$t('register.atLeastOneNumber') + brText
      }
      if(password != confPassword) {
        errorMessage += this.$t('register.unmatchingPasswords') + brText
      }
      if(errorMessage != baseErrorMessage) { // If there is at least one error, display them
        this.wrongAuthentificationMessage = errorMessage
        this.successMessage = ''
      }
      // Else, send the password to the backend. There it checks if the user exists and is authorized to change his password before
      // changing it. Throw an error if the user is unauthorized to do so.
      else {
        axios.post(this.$store.state.user.url + '/changePassword', {email: this.email, password: password, token: this.token} ).then(() => {
          this.password = ''
          this.confPassword = ''
          this.successMessage = this.$t('register.registerSuccess') + brText
        }).catch(() => {
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/register.sass"
</style>